import React from "react";
import SuperAdminLayout from "../Layout/SuperAdminLayout";
import Dashboard from "../pages/Dashboard";
import Login from "../components/Login/Login";
import { Navigate } from "react-router-dom";
import Companies from "../pages/Companies";
import Config from "../config/Config";
import Profile from "../pages/Profile";
import ForgotPassword from "../pages/ForgotPassword";
import Payments from "../components/payments/payments/Payments";
import CompanyCustomers from "../components/customers/company_customers/CompanyCustomers";

const SuperAdminRoutes = [
  {
    path: "/administrator",
    element: <SuperAdminLayout />,
    errorElement: <Navigate to="/administrator/login" replace />,
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "companies",
        element: <Companies />,
      },
      {
        path: "config",
        element: <Config />,
      },
      {
        path: "profile",
        element: <Profile />,
      },
      {
        path: "payments",
        element: <Payments />,
      },
      {
        path: "customers/:customID",
        element: <CompanyCustomers />,
      },
    ],
  },
  {
    path: "/administrator/login",
    element: <Login />,
  },
  {
    path: "/administrator/logout",
    element: <Login />,
  },
  {
    path: "/administrator/forgot-password",
    element: <ForgotPassword />,
  },
];
export default SuperAdminRoutes;
